import { render } from "./Selection.vue?vue&type=template&id=39e3ca42"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__